import {
  FETCH_SUMMARY_FFD_SLEEP_INIT,
  FETCH_SUMMARY_FFD_SLEEP_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_FAILURE,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_INIT,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_FAILURE,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_INIT,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_FAILURE,
  FETCH_SUMMARY_FFD_SLEEP_BPM_INIT,
  FETCH_SUMMARY_FFD_SLEEP_BPM_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_BPM_FAILURE,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_INIT,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_SUCCESS,
  FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_FAILURE,
  RESET_SUMMARY_FFD_SLEEP,
  SET_FILTER_SUMMARY_FFD_SLEEP
} from './types';
import API from './api';

/* Actions Creators */

export function setFilterSummaryFfdSleep(obj, loadingField = null) {
  return {
    type: SET_FILTER_SUMMARY_FFD_SLEEP,
    payload: {
      filter:obj,
      loadingField: loadingField
    }
  };
}

export function resetSummaryFfdSleep() {
  return {
    type: RESET_SUMMARY_FFD_SLEEP
  };
}

/* Data Main */
function fetchApiSuccess(data) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_INIT
  };
}

export function fetchSummaryFfdSleepApi(obj) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Data Table */
function fetchTableApiSuccess(data) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_SUCCESS,
    payload: data
  };
}

function fetchTableApiFailure(error) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_FAILURE,
    payload: error
  };
}

function fetchTableApiInit() {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_INIT
  };
}

export function fetchSummaryFfdSleepTableApi(obj) {
  return async dispatch => {
    dispatch(fetchTableApiInit());
    try {
      let data = await API.data.getTable(obj);
      dispatch(fetchTableApiSuccess(data));
    } catch (error) {
      dispatch(fetchTableApiFailure(error));
    }
  };
}

/* Data Table count */
function fetchTableCountApiSuccess(data) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_SUCCESS,
    payload: data
  };
}

function fetchTableCountApiFailure(error) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_FAILURE,
    payload: error
  };
}

function fetchTableCountApiInit() {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_COUNT_INIT
  };
}

export function fetchSummaryFfdSleepTableCountApi(obj) {
  return async dispatch => {
    dispatch(fetchTableCountApiInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchTableCountApiSuccess(data));
    } catch (error) {
      dispatch(fetchTableCountApiFailure(error));
    }
  };
}

/*  No loading */

function fetchTableNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_SUCCESS,
    payload: data,
    concat
  };
}

function fetchTableNoLoadingFailure(error) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchTableApiNoLoadingInit() {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_TABLE_NO_LOADING_INIT
  };
}

export function fetchSummaryFfdSleepTableNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchTableApiNoLoadingInit());
    try {
      let data = await API.data.getTable(obj);
      dispatch(fetchTableNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchTableNoLoadingFailure(error));
    }
  };
}

/* Data BPM */
function fetchBPMApiSuccess(data, concat) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_BPM_SUCCESS,
    payload: data,
    concat
  };
}

function fetchBPMApiFailure(error) {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_BPM_FAILURE,
    payload: error
  };
}

function fetchBPMApiInit() {
  return {
    type: FETCH_SUMMARY_FFD_SLEEP_BPM_INIT
  };
}

export function fetchSummaryFfdSleepBPMApi(obj) {
  return async dispatch => {
    dispatch(fetchBPMApiInit());
    try {
      let data = await API.data.getBPM(obj);
      dispatch(fetchBPMApiSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchBPMApiFailure(error));
    }
  };
}

export function downloadSummaryReport(filter) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadSummaryReport(filter);
    } catch (error) {}
  };
}

export function downloadNoProcessReport(filter) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadNoProcessReport(filter);
    } catch (error) {}
  };
}




// WEBPACK FOOTER //
// ./source/client/actions/summary_ffd_sleep/index.js